/* @flow */
import React from 'react'
import { WIDGETS } from '../../../constants'
import MenuItemWrapper from './StyledMenuItemWrapper'
import ItemDescription from './StyledItemDescription'
import EmailIcon from './EmailIcon'
import HoroscopeIcon from './HoroscopeIcon'
import MobileWeatherPreview from '../Weather/MobileWeatherPreview'
import { type MenuItemProps } from './Types'

const ITEM_CONTENT = {
  [WIDGETS.HOMEPAGE.EMAIL]: {
    content: <EmailIcon/>,
    displayName: 'E-mail'
  },
  [WIDGETS.HOMEPAGE.HOROSCOPES]: {
    content: <HoroscopeIcon/>,
    displayName: 'Horoskopy'
  },
  [WIDGETS.HOMEPAGE.WEATHER]: {
    content: <MobileWeatherPreview/>
  }
}

export default (props: MenuItemProps) => {
  const {
    handleWidgetSelection,
    isSelected,
    widgetName
  } = props

  const {
    content,
    displayName
  } = ITEM_CONTENT[widgetName]

  return (
    <MenuItemWrapper className={isSelected ? 'active' : ''} onClick={() => handleWidgetSelection(widgetName)}>
      { content }
      {
        displayName &&
        <ItemDescription>
          { displayName }
        </ItemDescription>
      }
    </MenuItemWrapper>
  )
}
